import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 54px;

  p {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.2px;
    text-align: right;
    color: ${({theme}) => theme.accent};
    margin-right: 14px;
    @media (max-width: ${({theme}) => theme.breakpoints.md}) {
      margin-right: 7px;
    }
  }
`

export const LeftSide = styled.div`
  align-items: center;

  button {
    all: unset;
    display: none;

    :hover {
      cursor: pointer;
    }
  }

  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    button {
      display: flex;
      align-items: center;
      justify-content: start;
    }
  }
`

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  .search_icon{
    margin-right: 28px;
    @media (max-width: ${({theme}) => theme.breakpoints.md}) {
      margin-right: 10px;
    }
  }
  
`

export const Profile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border-radius: 50%;
  border: 1.5px solid ${({theme}) => theme.grayDivider};

  :hover {
    cursor: pointer;
  }

  ul {
    position: absolute;
    height: fit-content;
    width: auto;
    top: 100%;
    left: 0;
    z-index: 1;
    padding: 8px 0;
    margin-top: 30px;
    transform: translateX(-100%);
    background: ${({theme}) => theme.white};
    border-radius: 6px;
    border: 1px solid ${({theme}) => theme.grayDivider};
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.06);
  }

  li {
    padding: 10px 16px;
    font-weight: 500;
    font-size: 14px;
    color: ${({theme}) => theme.accent};
    display: flex;
    align-items: center;
    justify-content: left;
    transition: all 300ms ease;

    :hover {
      background: ${({theme}) => theme.accentLightest};
    }
  }
`

export const DropDownContainer = styled.div`
  position: relative;
`

export const Divider = styled.div`
  height: 32px;
  width: 1px;
  margin: 0 33px 0 33px;
  background: ${({theme}) => theme.grayDivider};
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    margin: 0 10px 0 10px;
  }
`




